import { render } from "./PermissionDialogSetting.vue?vue&type=template&id=45f3513a"
import script from "./PermissionDialogSetting.vue?vue&type=script&lang=ts"
export * from "./PermissionDialogSetting.vue?vue&type=script&lang=ts"
script.render = render

export default script